export default class FrontpageSlider
{
    /**
     * @returns {void}
     */
    constructor(imageUrls, loopIntervalMs = 7000) {
        this.imageUrls = imageUrls;
        this.loopIntervalMs = loopIntervalMs;
    }

    /**
     * @params  {$dot}
     */
    start() {
        this.intervalId = setInterval(() => {
            this.showSlide(this.getNextDot(jQuery('.slide-dot.active')))
        }, this.loopIntervalMs);
    }

    stop()
    {
        // Stop the automatic interval.
        clearInterval(this.intervalId);
    }

    /**
     * @params  {$dot}
     */
    switch($dot) {
        this.showSlide($dot);
    }

    /**
     * @params {int} number
     */
    switchActiveSlideItem(number) {
        const self = this;
        const $activeSlider = jQuery('.slide-item.active');
        jQuery('.slide-item').removeClass('active');
        $activeSlider.fadeOut("slow", function(){
            self.switchBackgroundImage(number);
            jQuery('.slide-item[data-number="' + number + '"]').fadeIn("slow", function() {
                jQuery(this).addClass('active');
            });
        });
    }

    /**
     * @params {int} number
     */
    switchActiveDot(number) {
        jQuery('.slide-dot.active').removeClass('active');
        jQuery('.slide-dot[data-number="' + number + '"]').addClass('active');
    }

    /**
     * @params {int} number
     */
    switchBackgroundImage(number) {
        let imageSrc = this.imageUrls[number];
        const $headerArea = jQuery('#header-area');
        $headerArea.css('background-image', 'url(' + imageSrc + ')');

        // Restart slide animation
        $headerArea.removeClass("run-animation");
        $headerArea.width();
        $headerArea.addClass("run-animation");
    }

    /**
     * @params {jQuery} $currentSlide
     */
    getNextSlide($currentSlide) {
        const $nextEl = $currentSlide.next();
        if ($nextEl.length) {
            return $nextEl;
        }
        return jQuery('.slide-item[data-number="0"]');
    }

    /**
     * @params {jQuery} $currentDot
     */
    getNextDot($currentDot) {
        const $nextEl = $currentDot.next();
        if ($nextEl.length) {
            return $nextEl;
        }
        return jQuery('.slide-dot[data-number="0"]');
    }
    /**
     * @params {jQuery} $slideDot
     */
    showSlide($slideDot) {
        let number = $slideDot.data('number');

        this.switchActiveSlideItem(number);
        this.switchActiveDot(number)
    }

    preloadImages(imageUrls, callback) {
        let loadedCount = 0;
        imageUrls.forEach((imageUrl) => {
            const img = new Image();
            img.onload = () => {
                loadedCount++;
                if (loadedCount === imageUrls.length) {
                    callback();
                }
            };

            // Add a random query parameter to prevent caching
            img.src = imageUrl + '?v=' + Math.random();
        });
    }
}
